import React, { useEffect, useState } from "react";
import { IoCopyOutline } from "react-icons/io5";
import { TiTick } from "react-icons/ti";
import saveBotName from "./apis/saveBotName";
import { toast } from "react-toastify";
import DangerZone from "./DangerZone";

const General = ({ state, dispatch }) => {
  const [name, setName] = useState(state.selectedBot?.botName || "");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setName(state.selectedBot?.botName || "");
  }, [state.selectedBot]);

  const handleCopy = () => {
    if (!state.selectedBot?.botId) return;

    navigator.clipboard.writeText(state.selectedBot.botId);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error("Bot name cannot be empty.");
      return;
    }

    const res = await saveBotName(state.selectedBot?.botId, name);
    if (res.error) {
      toast.error(res.msg || "Failed to update bot name.");
      return;
    }

    toast.success(res.msg || "Bot name updated successfully.");
    const bots = state.bots;
    const bot = bots?.filter((ele) => ele?.botId !== state?.selectedBot?.botId);
    dispatch({ type: "SET_BOTS", payload: [...bot, res.data] });

    dispatch({ type: "SET_SELECTED_BOT", payload: res.data });
    return;
  };

  return (
    <div className="bg-white">
      <div className="bg-white px-6 py-8 rounded-2xl shadow-lg border border-gray-200">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900">General Settings</h2>
          <p className="text-gray-500 mt-1 text-sm">
            Manage your bot’s identity and essential details.
          </p>
        </div>

        {/* Bot ID */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Chatbot ID
          </label>
          <div className="flex items-center gap-3 mt-2">
            <span className="text-gray-800  font-mono bg-gray-100 px-3 py-2 rounded-md font-bold truncate text-xl">
              {state.selectedBot?.botId}
            </span>
            <button
              onClick={handleCopy}
              className="p-2 rounded-md bg-gray-100 hover:bg-gray-200 transition border border-gray-300"
              title="Copy Bot ID">
              {copied ? <TiTick size={18} /> : <IoCopyOutline size={18} />}
            </button>
          </div>
        </div>

        {/* Bot Name Input */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Bot Name
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter bot name"
          />
        </div>

        {/* Save Button */}
        <div className="flex justify-end">
          <button
            onClick={handleSave}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition">
            Save Changes
          </button>
        </div>
      </div>
      <div className="w-full text-red-500 flex gap-3 my-5 items-center justify-center">
        <div className="flex-1 h-px bg-red-500"></div>
        <h4>Danger Zone</h4>
        <div className="flex-1 h-px bg-red-500"></div>
      </div>
      <DangerZone
        botId={state?.selectedBot?.botId}
        bots={state?.bots}
        dispatch={dispatch}
      />
    </div>
  );
};

export default General;
